// must not be changed, used by 3rd party integrators - please talk to ariel livshits before changing
export var WixHtmlAttributes;
(function (WixHtmlAttributes) {
    WixHtmlAttributes["DataWixPrice"] = "data-wix-price";
    WixHtmlAttributes["DataWixOriginalPrice"] = "data-wix-original-price";
    WixHtmlAttributes["DataWixCheckoutButton"] = "data-wix-checkout-button";
    WixHtmlAttributes["DataWixHideable"] = "data-wix-hideable";
    WixHtmlAttributes["DataWixIgnoreable"] = "data-wix-ignorable";
    WixHtmlAttributes["DataWixPricePerUnit"] = "data-wix-price-per-unit";
    WixHtmlAttributes["DataWixQuantity"] = "data-wix-quantity";
    WixHtmlAttributes["DataWixShowable"] = "data-wix-showable";
})(WixHtmlAttributes || (WixHtmlAttributes = {}));
//# sourceMappingURL=wix-html-attributes.js.map